import React from "react";
import { Route, Redirect } from "react-router-dom";

function UnauthenticatedRoute({ component: C, appProps, ...rest }) {
  return <Route {...rest} render={(props) => <C {...props} {...appProps} />} />;
}

export default UnauthenticatedRoute;
